import StudentInfoService from "../../apiServices/student/studentInfoService"
import { setStudentInfo } from "../../store/slices/student/studentInfoSlice";


export function getStudentInfoDetails(id:string){
    return async function (dispatch: any, getState: any) {
        let response = await StudentInfoService.getStudentInfo(id)
        if (response?.success === true) {
          dispatch(setStudentInfo(response.data));
        } else {
          console.log("error");
        }
      };
}